/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 6/28/2016
 * Time: 12:49 PM
 */
if (!global._babelPolyfill) {
  require('babel-polyfill');
}



/** WEBPACK FOOTER **
 ** ./src/main/js/common/index.js
 **/